export type TRegisterRoundInfoFormValues = {
  courseInfoId: number | null;
  chartRound: number | null;
  chartName: string;
  chartTypeList: number[];
  firstSubmitStartDate: string;
  firstSubmitEndDate: string;
  secondSubmitStartDate?: string;
  secondSubmitEndDate?: string;
};

export enum RegisteredRoundSortingLabel {
  ChartRoundAndChartName = '(회차) 회차명',
  FirstSubmitEndDate = '1차 마감 일자',
  SecondSubmitEndDate = '2차 마감 일자',
}

export enum RegisteredRoundSortType {
  ChartRoundAndChartName = 'chartRoundAndChartName',
  FirstSubmitEndDate = 'firstSubmitEndDate',
  SecondSubmitEndDate = 'secondSubmitEndDate',
}

export type TDeleteRoundInfoFormValues = {
  password: string;
};

export enum RegisterRoundFormField {
  CourseInfoId = 'courseInfoId',
  ChartRound = 'chartRound',
  ChartName = 'chartName',
}
